// Gonzaga University's undergraduate majors (#2839). Read on 2026-10-01
// from the official 2026-2027 Academic Catalog (catalog.gonzaga.edu, read in
// a headless browser because the catalog answers plain requests with an
// empty 202). The list is every "Name (degree)" bachelor's line on the
// catalog's Degree Paths page (/programs/): 61 programs; minors,
// certificates and graduate degrees left out. The catalog's Degree Paths
// page does not group programs, so each is placed under the school whose
// undergraduate catalog section lists its department: Business
// Administration ("The degree of Bachelor of Business Administration
// (B.B.A.) is offered with a major in accounting, business administration,
// or marketing", plus the Economics B.A. and B.S. majors), Education (its
// four B.Ed. degrees), Engineering and Applied Science (its departments),
// Health Sciences (Human Physiology, Nursing, Public Health), and the
// College of Arts and Sciences for the rest. Marketing (BBA) links to the
// catalog's next edition from the Degree Paths page; the business section
// of this edition lists the marketing major. The catalog writes the school
// "School of Engineering & Applied Science" in places; the name here uses
// "and".
const majors = {
    "slug": "gonzaga-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Gonzaga's official 2026-2027 Undergraduate Catalog, grouped by the college or school that offers it, with the degree it leads to. Minors, concentrations, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Gonzaga 2026-2027 Undergraduate Catalog, College of Arts and Sciences",
                "url": "https://catalog.gonzaga.edu/undergraduate/arts-sciences/"
            },
            "majors": [
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biophysics",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Classical Civilizations",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Criminology",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Digital Media Production",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Experimental Data Analysis",
                    "degree": "BS"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Italian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music Education",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Public Relations",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BA"
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Business Administration",
            "source": {
                "label": "Gonzaga 2026-2027 Undergraduate Catalog, School of Business Administration",
                "url": "https://catalog.gonzaga.edu/undergraduate/business-administration/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration",
                    "degree": "BBA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "Gonzaga 2026-2027 Undergraduate Catalog, School of Education",
                "url": "https://catalog.gonzaga.edu/undergraduate/education/"
            },
            "majors": [
                {
                    "name": "Community, Culture, and Language",
                    "degree": "BEd"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BEd"
                },
                {
                    "name": "Special Education",
                    "degree": "BEd"
                },
                {
                    "name": "Sport Management",
                    "degree": "BEd"
                }
            ]
        },
        {
            "name": "School of Engineering and Applied Science",
            "source": {
                "label": "Gonzaga 2026-2027 Undergraduate Catalog, School of Engineering and Applied Science",
                "url": "https://catalog.gonzaga.edu/undergraduate/engineering-applied-science/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Management",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Health Sciences",
            "source": {
                "label": "Gonzaga 2026-2027 Undergraduate Catalog, School of Health Sciences",
                "url": "https://catalog.gonzaga.edu/undergraduate/health-sciences/"
            },
            "majors": [
                {
                    "name": "Human Physiology",
                    "degree": "BS"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Public Health",
                    "degree": "BA"
                }
            ]
        }
    ]
};

export default majors;
